module.exports = __webpack_public_path__ + "static/media/grid_screen_1.50d15825.jpg";